module.exports = __webpack_public_path__ + "img/74.e30cf904.jpg";